import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: "Чи обов'язкова моя присутність у суді?",
  answer: 'Ні. Я повністю беру на себе представництво ваших інтересів. Ви можете знаходитись в іншому місті або навіть за кордоном — процес буде йти без вашої фізичної участі.'
}, {
  question: 'Скільки часу займає розлучення?',
  answer: 'За взаємною згодою та без дітей — від 1 місяця. Через суд (за наявності дітей або спору) — в середньому від 2 до 4 місяців. Я роблю все можливе, щоб прискорити цей процес.'
}, {
  question: 'Чи можна розлучитися, якщо чоловік/дружина проти?',
  answer: 'Так, за законодавством України шлюб може бути розірваний навіть без згоди одного з подружжя. Процедура проходить виключно через суд, і я допоможу зробити це максимально безболісно.'
}, {
  question: 'Як стягнути аліменти, якщо колишній чоловік не працює офіційно?',
  answer: 'В такому випадку аліменти стягуються у твердій грошовій сумі або виходячи з середньої заробітної плати по регіону. Ми оберемо найвигідніший для вас варіант.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-52">
      <div className="container mx-auto px-6" data-id="element-53">
        <div className="max-w-3xl mx-auto" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-55">
            <h2 className="text-4xl font-normal tracking-tight text-neutral-900 mb-4" data-id="element-56">
              Часті <span className="font-semibold" data-id="element-57">питання</span>
            </h2>
            <p className="text-neutral-600 font-normal" data-id="element-58">
              Відповіді на те, що найчастіше турбує клієнтів
            </p>
          </motion.div>

          <div className="space-y-4" data-id="element-59">
            {faqs.map((faq, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="border border-neutral-200 rounded-2xl overflow-hidden" data-id="element-60">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-neutral-50 transition-colors" data-id="element-61">
                  <span className="font-medium text-neutral-900 pr-8" data-id="element-62">
                    {faq.question}
                  </span>
                  {openIndex === idx ? <Minus className="w-5 h-5 text-neutral-400 shrink-0" data-id="element-63" /> : <Plus className="w-5 h-5 text-neutral-900 shrink-0" data-id="element-64" />}
                </button>
                <AnimatePresence data-id="element-65">
                  {openIndex === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-66">
                      <div className="p-6 pt-0 text-neutral-600 font-normal leading-relaxed border-t border-neutral-100" data-id="element-67">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}